<template>
 <div class="member-detail">
   <div class="container-fluid">
     <sidebar />
     <div class="col-md-9 col-lg-10 ml-md-auto py-4">
       <div id="scroll" class="header d-flex justify-content-start w-100 align-items-center py-3 mb-5 border-bottom border-dark">
         <h2 class="my-3">会員情報編集</h2>
       </div>
      <div v-if="apiStatus">
        {{statusAlert(true)}}
      </div>
      <div v-if="invalidEmail" class="validation py-3 px-5 my-4">
          <p class="m-0">エラー：すべてのフィールドを確認して、再試行してください</p>
      </div>
      <div v-show="error" class="validation py-3 px-5 my-4">
          <p class="m-0">{{ error }}</p>
      </div>
       <div class="main-bg mb-4 p-3 mb-2 bg-light text-dark" v-if="memberData">
         <b-container fluid v-if="memberData.memberinfo">

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">氏名</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="$v.memberData.memberinfo.fullname.$model" class="form-input" placeholder="山田" :state="validateState('fullname')"></b-form-input>
                <b-form-invalid-feedback :state="validateState('fullname')">
                    <p v-if="!$v.memberData.memberinfo.fullname.required">氏名は必須です</p>
                    <p v-if="!$v.memberData.memberinfo.fullname.maxLength">30文字以下で入力してください</p>
                    <p v-if="!$v.memberData.memberinfo.fullname.minLength">氏名{{$v.memberData.memberinfo.fullname.$params.minLength.min}}文字以上入力してください</p>
                </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">フリガナ</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="$v.memberData.memberinfo.fullname_furigana.$model" class="form-input" placeholder="ヤマダ" :state="validateState('fullname_furigana')"></b-form-input>
                <b-form-invalid-feedback :state="validateState('fullname_furigana')">
                  <p v-if="!$v.memberData.memberinfo.fullname_furigana.maxLength">30文字以下で入力してください</p>
                  <p v-if="!$v.memberData.memberinfo.fullname_furigana.minLength">氏名{{$v.memberData.memberinfo.fullname_furigana.$params.minLength.min}}文字以上入力してください</p>
                </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">メールアドレス</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="$v.memberData.email_address.$model" class="form-input" placeholder="global@lead-real.co.jp" :state="validateEmail('email_address')"></b-form-input>
              <b-form-invalid-feedback :state="validateEmail('email_address')">
                <p v-if="$v.$invalid">{{emailCheck()}}</p>
                <p v-if="!$v.memberData.email_address.required">メールアドレスを入力してください</p>
                <p v-if="!$v.memberData.email_address.email">メールアドレスを正しく入力してください</p>
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-if="!$v.$invalid" :state="false">
                <p v-if="invalidEmail">このメールアドレスは使用できません。</p>
              </b-form-invalid-feedback>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">パスワード</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="memberData.password" type="text" class="form-input" placeholder="********"></b-form-input>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">国名</label>
            </b-col>
            <b-col lg="4">
              <b-form-select v-model="$v.memberData.memberinfo.country.$model" class="form-select" :state="validateState('country')" @change="changeCountry">
                <b-form-select-option :value="null" disabled>選択してください</b-form-select-option>
                <b-form-select-option  v-for="(country, index) in countries" :key="index" :value="country">{{country}}</b-form-select-option>
              </b-form-select>
              <b-form-invalid-feedback :state="validateState('country')">
                <p v-if="!$v.memberData.memberinfo.country.required">国名は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">郵便番号</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="$v.memberData.memberinfo.postal_code.$model" class="form-input" placeholder="123-4567" :state="validateState('postal_code')"></b-form-input>
              <b-form-invalid-feedback :state="validateState('postal_code')">
                <p v-if="!$v.memberData.memberinfo.postal_code.required">郵便番号は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">都道府県</label>
            </b-col>
            <b-col lg="4">
              <b-form-select v-model="memberData.memberinfo.prefectures" class="form-select" :disabled="memberData.memberinfo.country !== 'Japan'">
                <b-form-select-option :value="null" disabled>選択してください</b-form-select-option>
                <b-form-select-option  v-for="(prefecture, index) in countriesPrefectures" :key="index" :value="prefecture">{{prefecture}}</b-form-select-option>
              </b-form-select>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">住所</label>
            </b-col>
            <b-col lg="10">
              <b-form-input v-model="$v.memberData.memberinfo.address.$model" class="form-input" placeholder="渋谷区南平台町16-11" :state="validateState('address')"></b-form-input>
              <b-form-invalid-feedback :state="validateState('address')">
                <p v-if="!$v.memberData.memberinfo.address.required">住所すは必須です</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">電話番号</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="memberData.memberinfo.phone_number" class="form-input" placeholder="11-1111-1111"></b-form-input>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">FAX番号</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="memberData.memberinfo.fax_number" class="form-input" type="tel" maxlength="12" placeholder="22-2222-2222"></b-form-input>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">年齢</label>
            </b-col>
            <b-col lg="4" class="d-flex align-items-center">
              <b-form-select v-model="$v.memberData.memberinfo.age.$model" class="form-select" :state="validateState('age')">
                <b-form-select-option :value="null" disabled="disabled" selected>選択してください</b-form-select-option>
                <b-form-select-option v-for="(item, index) in ageSetup" :key="index" :value="item">{{item + $t('exts')}}</b-form-select-option>
              </b-form-select>
              <b-form-invalid-feedback :state="validateState('age')">
                <p v-if="!$v.memberData.memberinfo.age.required">年齢は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">性別</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-group class="m-0 form-radio-button">
                <b-form-radio-group v-model="$v.memberData.memberinfo.gender.$model" :state="validateState('gender')">
                  <b-form-radio value="Male">男性</b-form-radio>
                  <b-form-radio value="Female">女性</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-invalid-feedback :state="validateState('gender')">
                <p v-if="!$v.memberData.memberinfo.gender.required">性別は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">物件用途</label>
            </b-col>
            <b-col lg="4" class="d-flex align-items-center">
              <b-form-group class="m-0 form-radio-button">
                <b-form-radio-group v-model="$v.memberData.memberinfo.use_of_the_property.$model" :state="validateState('use_of_the_property')">
                  <b-form-radio v-for="item in propertyUses" :key="item" :value="item">{{$t(item)}}</b-form-radio>
                </b-form-radio-group>
              <b-form-invalid-feedback :state="validateState('use_of_the_property')">
                <p v-if="!$v.memberData.memberinfo.use_of_the_property.required">物件用途は必須です</p>
              </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">検討中の物件種別</label>
            </b-col>
            <b-col lg="4">
              <b-form-select v-model="$v.memberData.memberinfo.types_of_properties.$model" class="form-select" :state="validateState('types_of_properties')">
                <b-form-select-option value="null" disabled="disabled" selected>選択してください</b-form-select-option>
                <b-form-select-option v-for="item in propertyType" :key="item" :value="item">{{$t(item)}}</b-form-select-option>
              </b-form-select>
              <b-form-invalid-feedback :state="validateState('types_of_properties')">
                <p v-if="!$v.memberData.memberinfo.types_of_properties.required">検討中の物件種別は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">希望価格帯</label>
            </b-col>
            <b-col lg="4">
              <b-form-select v-model="$v.memberData.memberinfo.desired_price_range.$model" class="form-select" :state="validateState('desired_price_range')">
                <b-form-select-option value="null" disabled="disabled" selected>選択してください</b-form-select-option>
                <b-form-select-option v-for="item in price" :key="item" :value="item">{{$t(item)}}</b-form-select-option>
              </b-form-select>
              <b-form-invalid-feedback :state="validateState('desired_price_range')">
                <p v-if="!$v.memberData.memberinfo.desired_price_range.required">希望価格帯は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">メルマガ配信</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-group class="m-0 form-radio-button">
                <b-form-radio-group v-model="$v.memberData.memberinfo.email_magazine_delivery.$model" :state="validateState('email_magazine_delivery')">
                  <b-form-radio value="ok">OK</b-form-radio>
                  <b-form-radio value="ng">NG</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-invalid-feedback :state="validateState('email_magazine_delivery')">
                <p v-if="!$v.memberData.memberinfo.email_magazine_delivery.required">メルマガ配信は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">言語</label>
            </b-col>
            <b-col lg="4">
              <b-form-select v-model="$v.memberData.memberinfo.language.$model" class="form-select" :state="validateState('language')" :options="language"></b-form-select>
              <b-form-invalid-feedback :state="validateState('language')">
                <p v-if="!$v.memberData.memberinfo.language.required">言語は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">プラン</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <span>{{ memberData.plan }}</span>
            </b-col>
          </b-row>
          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">会社名</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="memberData.memberinfo.company_name" class="form-input" placeholder="株式会社リード・リアルエステート"></b-form-input>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">会社概要</label>
            </b-col>
            <b-col lg="4">
              <b-form-textarea v-model="memberData.memberinfo.company_description" class="form-input"></b-form-textarea>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">業種</label>
            </b-col>
            <b-col lg="3" class="align-items-center d-flex">
              <b-form-checkbox
                id="business_type_indivisual"
                v-model="memberData.memberinfo.business_type_indivisual"
                value="1"
                unchecked-value="0">
                <label for="business_type_indivisual" class="checkbox">{{ $t('business_type_indivisual') }}</label>
              </b-form-checkbox>
            </b-col>
            <b-col lg="3" class="align-items-center d-flex">
              <b-form-checkbox
                id="business_type_developer"
                v-model="memberData.memberinfo.business_type_developer"
                value="1"
                unchecked-value="0">
                <label for="business_type_developer" class="checkbox">{{ $t('business_type_developer') }}</label>
              </b-form-checkbox>
            </b-col>
            <b-col lg="3" class="align-items-center d-flex">
              <b-form-checkbox
                id="business_type_mediator"
                v-model="memberData.memberinfo.business_type_mediator"
                value="1"
                unchecked-value="0">
                <label for="business_type_mediator" class="checkbox">{{ $t('business_type_mediator') }}</label>
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">エリア</label>
            </b-col>
            <b-col lg="4">
              <b-form-select v-model="memberData.memberinfo.area" class="form-select">
                <b-form-select-option :value="null">選択して下さい</b-form-select-option>
                <b-form-select-option  v-for="(area, index) in prefectures" :key="index" :value="area">{{area}}</b-form-select-option>
              </b-form-select>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">エリア詳細</label>
            </b-col>
            <b-col lg="4">
              <b-form-textarea v-model="memberData.memberinfo.area_detail" class="form-input"></b-form-textarea>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">会員登録日</label>
            </b-col>
            <b-col lg="4">
              <p class="m-0">{{ this.moment(memberData.created_at).format('YYYY/MM/DD') }}</p>
            </b-col>
          </b-row>
        </b-container>
       </div>
       <div class="d-flex justify-content-between align-items-center mb-3">
          <a href="#scroll" class="text-decoration-none text-white" v-smooth-scroll><b-button class="py-3 px-5" variant="primary" @click="updateThisMember">更新</b-button></a>
          <b-button class="py-3 px-5" variant="danger" v-b-modal.modal-delete>削除</b-button>
       </div>
        <b-modal id="modal-delete" ref="modal-delete" class="del-member" hide-footer hide-header centered title="BootstrapVue">
          <h6 class="m-4 text-center">本当に削除してもよろしいですか？</h6>
          <div class="d-flex justify-content-center align-items-center">
            <b-button class="py-3 px-5 mr-3" variant="primary" @click="hideModal">キャンセル</b-button>
            <b-button class="py-3 px-5" variant="danger" v-b-modal.modal-delete @click="deleteThisMember">削除</b-button>
          </div>
        </b-modal>
     </div>
   </div>
 </div>
</template>

<script>
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
import { mapState, mapActions } from 'vuex'
import sidebar from '@/components/_sidebar/sidebar'
import { languages, memberAges, businessPropertyValues, propertyUses, propertyPrices } from '../../assets/data/values'

export default {
  data () {
    return {
      status: null,
      loadingState: false,
      residentialList: businessPropertyValues.propertyTypes.residential,
      investmentList: businessPropertyValues.propertyTypes.investment,
      price: propertyPrices,
      propertyUses: propertyUses,
      ageSetup: memberAges,
      language: [{ text: '選択してください', disabled: true }].concat(languages.map(l => { return { value: l, text: this.$i18n.t(l) } })),
      privileged: null,
      error: null
    }
  },
  validations: {
    memberData: {
      memberinfo: {
        fullname: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(30)
        },
        fullname_furigana: {
          minLength: minLength(2),
          maxLength: maxLength(30)
        },
        country: { required },
        address: {
          required,
          maxLength: maxLength(80)
        },
        age: { required },
        postal_code: { required },
        gender: { required },
        use_of_the_property: { required },
        desired_price_range: { required },
        types_of_properties: { required },
        language: { required },
        email_magazine_delivery: { required },
        password: { minLength: minLength(8) }
      },
      email_address: {
        required,
        email
      }
    }
  },
  created () {
    this.getMember(this.$route.params.id)
    this.$store.commit('adminEditMember/setInvalidEmail', null)
    this.prefectureCountry()
  },
  computed: {
    ...mapState(['errors', 'apiStatus']),
    ...mapState('adminEditMember', ['memberData', 'progress', 'invalidEmail']),
    ...mapState('adminAddMember', ['countries', 'prefectures']),
    countriesPrefectures () {
      switch (this.selectedCountry) {
        case 'japan':
          return this.prefectures
        case 'other':
          return this.countries
        default:
          return this.prefectures
      }
    },
    propertyType () {
      if (this.memberData.memberinfo.use_of_the_property === 'Residential use') {
        return this.residentialList
      }
      return this.investmentList
    }
  },
  methods: {
    ...mapActions('adminAddMember', ['prefectureCountry']),
    ...mapActions('adminEditMember', ['getMember', 'updateMember', 'deleteMember']),
    validateState (name) {
      const { $dirty, $error } = this.$v.memberData.memberinfo[name]
      return $dirty ? !$error : null
    },
    validateEmail (name) {
      const { $dirty, $error } = this.$v.memberData[name]
      return $dirty ? !$error : null
    },
    handleClick () {
      this.loadingState = true
    },
    deleteThisMember () {
      this.deleteMember(this.memberData)
    },
    updateThisMember () {
      if (this.memberData.password === undefined) {
        this.memberData.memberinfo.password = null
      }
      const updatedMemberinfo = {}
      updatedMemberinfo.memberinfo = {
        fullname: this.memberData.memberinfo.fullname,
        fullname_furigana: this.memberData.memberinfo.fullname_furigana,
        password: this.memberData.password,
        email_address: this.memberData.email_address,
        postal_code: this.memberData.memberinfo.postal_code,
        country: this.memberData.memberinfo.country,
        prefectures: this.memberData.memberinfo.prefectures,
        address: this.memberData.memberinfo.address,
        phone_number: this.memberData.memberinfo.phone_number,
        fax_number: this.memberData.memberinfo.fax_number,
        age: this.memberData.memberinfo.age,
        gender: this.memberData.memberinfo.gender,
        use_of_the_property: this.memberData.memberinfo.use_of_the_property,
        desired_price_range: this.memberData.memberinfo.desired_price_range,
        types_of_properties: this.memberData.memberinfo.types_of_properties,
        language: this.memberData.memberinfo.language,
        email_magazine_delivery: this.memberData.memberinfo.email_magazine_delivery,
        company_name: this.memberData.memberinfo.company_name,
        company_description: this.memberData.memberinfo.company_description,
        business_type_developer: this.memberData.memberinfo.business_type_developer,
        business_type_mediator: this.memberData.memberinfo.business_type_mediator,
        business_type_indivisual: this.memberData.memberinfo.business_type_indivisual,
        area: this.memberData.memberinfo.area,
        area_detail: this.memberData.memberinfo.area_detail
      }
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.error = 'エラー：すべてのフィールドを確認して、再試行してください'
      } else {
        this.updateMember(updatedMemberinfo.memberinfo)
        if (this.invalidEmail !== null) {
          this.$v.memberData.email_address.$reset()
        }
        this.$nextTick(() => {
          this.$v.$reset()
        })
        this.error = null
      }
    },
    hideModal () {
      this.$refs['modal-delete'].hide()
    },
    emailCheck: function () {
      this.$store.commit('adminEditMember/setInvalidEmail', null)
    },
    statusAlert (append = false) {
      this.$bvToast.toast('body', {
        title: this.apiStatus,
        toaster: 'b-toaster-top-center',
        solid: true,
        appendToast: append,
        autoHideDelay: 3000
      })
    },
    changeCountry () {
      if (this.memberData.memberinfo.country !== 'Japan') {
        this.memberData.memberinfo.prefectures = null
      }
    }
  },
  watch: {
    apiStatus: function () {
      this.error = null
      this.$store.commit('adminEditMember/setInvalidEmail', null)
    }
  },
  components: {
    sidebar
  }
}
</script>
